import React from "react";

import LoginPage from "./pages/login/LoginPage";
import {Page404, Page500} from "./Pages";

import {IndexPage} from "./pages/index/IndexPage";
import WorkbenchPage from "./pages/workbench/WorkbenchPage";
import SystemSettingsPage from "./pages/setting/SystemSettingsPage";
import UserRoleManagerPage from "./pages/user/UserRoleManagerPage";
import ChangePasswordPage from "./pages/login/ChangePasswordPage";
import AppDownloadPage from "./pages/login/AppDownloadPage";
import ModifyPasswordPage from "./pages/login/ModifyPasswordPage";
import ApplicationPage from "./pages/application/ApplicationPage";
import DictionaryPage from "./pages/dictionary/DictionaryPage";
import UserMemberManagementPage from "./pages/user/UserMemberManagementPage";
import ProfilePage from "./pages/personal/ProfilePage";
import UnifiedLoginPage from "./pages/unite/UnifiedLoginPage";
import TaskReceiverPage from "./pages/workbench/TaskReceiverPage";

export const routes = [
    {
        path: '/login',
        exact: true,
        component: LoginPage
    },
    {
        path:'/change/password',
        exact:true,
        component:ChangePasswordPage
    },
    {
        path:'/change/newPassword',
        exact:true,
        component:ModifyPasswordPage
    },
    {
        path:'/download',
        exact:true,
        component:AppDownloadPage
    },
    {
        path: '/',
        component: IndexPage,
        routers: [
            {
                path: '/',
                exact: true,
                component: WorkbenchPage
            },
            {
                path: '/site',
                exact: true,
                component: SystemSettingsPage
            },
            {
                path:'/role/permission/manager',
                exact:true,
                component:UserRoleManagerPage
            },
            {
                path: '/application/list',
                exact: true,
                component: ApplicationPage
            },
            {
                path: '/site/dictionary',
                exact: true,
                component: DictionaryPage
            },
            {
                path:'/user/manager',
                exact:true,
                component:UserMemberManagementPage
            },
            {
                path: '/site/profile',
                exact: true,
                component: ProfilePage
            },
            {
                path: '/unified',
                exact: true,
                component: UnifiedLoginPage
            },
            {
                path: '/task/receive',
                exact: true,
                component: TaskReceiverPage
            },
            {
                component: Page404
            }
        ]
    },
    {
        path: '/500',
        exact: true,
        component: Page500
    },
    {
        component: Page404
    }
];
